import {Type} from "class-transformer";
import {serializeType} from "@app/shared/classes/common";

import {AbstractItem} from "@app/shared/classes/item";
import {ItemType} from "@app/shared";

export class SalesReturnItem {
  id: number;
  nameOrNumber: string;
  subtype: ItemType;
  description: string;
  version: number;
  returnReason: string;
  qtyReturned: number;
  qtyOrdered: number;
  qtyShipped: number;
  salesPrice: number;
  creditAmount: number;
  taxAmount: number;
  isTaxable: boolean;
  packingSlipItemId: number;
  salesReturnId: number;
  @Type(serializeType(AbstractItem)) abstractItemDetail: AbstractItem;
}
